import { Controller } from "@hotwired/stimulus"

import Stimulus from "../../common/utils/stimulus"

class FaqPageFeedback extends Controller {
  static classes = [`formActive`]

  formActivate() {
    this.element.classList.add(this.formActiveClass)
  }

  formDeactivate() {
    this.element.classList.remove(this.formActiveClass)
  }
}

Stimulus.register(`faq-page-feedback`, FaqPageFeedback)
